let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("h2MrD"), load("bYT2S"), load("55CDW")]).then(() => parcelRequire('e8Z1Y'));